import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

// Banner fix în top afișat când SUPER_ADMIN e într-o sesiune de impersonare.
// Backend-ul setează `user.impersonatedBy = { id, firstName, lastName, email }` din claim-ul JWT.
const ImpersonationBanner = () => {
  const { t } = useTranslation();
  const { user, stopImpersonation } = useAuth();
  const [loading, setLoading] = useState(false);

  if (!user?.impersonatedBy) return null;

  const handleStop = async () => {
    setLoading(true);
    const res = await stopImpersonation();
    if (!res.success) {
      alert(res.error);
      setLoading(false);
    }
  };

  const adminName =
    `${user.impersonatedBy.firstName || ''} ${user.impersonatedBy.lastName || ''}`.trim() ||
    user.impersonatedBy.email;

  return (
    <div className="sticky top-0 z-[60] bg-amber-500 text-slate-900 border-b-2 border-amber-700 shadow-md">
      <div className="flex items-center justify-between gap-3 px-4 lg:px-6 py-2 text-sm">
        <div className="flex items-center gap-2 min-w-0">
          <svg
            className="w-5 h-5 flex-shrink-0"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v2m0 4h.01M4.93 19h14.14c1.54 0 2.5-1.67 1.73-3L13.73 4a2 2 0 00-3.46 0L3.2 16c-.77 1.33.19 3 1.73 3z"
            />
          </svg>
          <span className="truncate">
            <strong>{t('impersonation.active')}:</strong> {t('impersonation.loggedAs')}{' '}
            <strong>
              {user.firstName} {user.lastName}
            </strong>
            <span className="hidden sm:inline">
              {' '}
              ({t('impersonation.originalAccount')}: {adminName})
            </span>
          </span>
        </div>
        <button
          onClick={handleStop}
          disabled={loading}
          className="flex-shrink-0 bg-slate-900 text-amber-100 hover:bg-slate-800 disabled:opacity-50 px-3 py-1.5 rounded-md text-xs font-semibold transition-colors"
        >
          {loading ? t('impersonation.returning') : t('impersonation.returnToAccount')}
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
